import { PnlAxisColumn } from 'src/components/star-grid/pnlAxis.types';
import { PNL_ACTUALS_SCENARIO_ID } from 'src/components/star-grid/starGridConstants';
import { PnlPivotColumn, PnlPivotColumnGroup, PnlScenarioEntry } from 'src/components/star-grid/starGridTypes';
import { effectiveScenarioId } from 'src/components/star-grid/utils/pnlPeriods';

export const pnlAxisField = (index: number): string => `axis_c${index}`;
const quarter = (month: number): string => `${Math.floor(month / 100)}Q${Math.ceil((month % 100) / 3)}`;

const axisPeriodType = (column: PnlAxisColumn, scenarios: readonly PnlScenarioEntry[]): PnlPivotColumn['periodType'] => {
  if (column.kind === 'variance') return column.exfx ? 'varianceExFx' : 'variance';
  const scenario = scenarios.find((entry) => entry.label === column.group);
  if (!scenario) return undefined;
  const period = column.period ?? '';
  const months = /^\d{6}$/.test(period) ? [Number(period)] : scenario.months.filter((month) => quarter(month) === period);
  const types = new Set(
    months.map((month) => (effectiveScenarioId(scenario, month) === PNL_ACTUALS_SCENARIO_ID ? ('actual' as const) : ('forecast' as const)))
  );
  return types.size === 1 ? [...types][0] : undefined;
};

const axisColumn = (column: PnlAxisColumn, scenarios: readonly PnlScenarioEntry[]): PnlPivotColumn => ({
  field: pnlAxisField(column.index),
  colId: pnlAxisField(column.index),
  headerName: column.label,
  periodType: axisPeriodType(column, scenarios)
});

/** Keep contiguous groups and explicit spacers in the server's order. */
export const pnlAxisColumnGroups = (columns: readonly PnlAxisColumn[], scenarios: readonly PnlScenarioEntry[]): PnlPivotColumnGroup[] => {
  const groups: PnlPivotColumnGroup[] = [];
  for (const column of columns) {
    const previous = groups[groups.length - 1];
    const isSpacer = column.kind === 'spacer';
    const label = column.group ?? '';
    if (isSpacer || !previous || previous.isSpacer || previous.group_label !== label) {
      groups.push({ group_id: `axis_group_${column.index}`, group_label: label, isSpacer, columns: [] });
    }
    if (!isSpacer) groups[groups.length - 1].columns.push(axisColumn(column, scenarios));
  }
  return groups;
};
